module.exports = __webpack_public_path__ + "static/media/loader.6b707e93.gif";